import React from "react";
import { useLang } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin } from "lucide-react";

export default function Footer() {
  const { t, lang } = useLang();
  const legalLabel = lang === "fr" ? "Mentions légales" : "Legal notice";
  const rgpdLabel = lang === "fr" ? "RGPD · Confidentialité" : "GDPR · Privacy";
  return (
    <footer data-testid="site-footer" className="bg-navy text-ivory mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-7">
            {/* Signature slogan — aligned vertically with the phone contact line */}
            <p className="font-serif text-2xl md:text-3xl font-light leading-[1.15] text-ivory/95 max-w-2xl md:mt-12">
              {t.footer.cta}
            </p>
          </div>
          <div className="md:col-span-5">
            <ul className="space-y-3 text-sm text-ivory/85">
              <li className="flex items-start gap-3"><MapPin size={14} className="mt-1 text-brand" /><span>{t.footer.address}</span></li>
              <li className="flex items-center gap-3"><Phone size={14} className="text-brand" /><a href="tel:+33652303000" className="link-underline">+33 (0)6 52 30 30 00</a></li>
              <li className="flex items-center gap-3"><Mail size={14} className="text-brand" /><a href="mailto:contact@audace-perspectives.com" className="link-underline">contact@audace-perspectives.com</a></li>
              <li className="flex items-center gap-3"><Linkedin size={14} className="text-brand" /><a href="https://www.linkedin.com/company/audaceperspectives/" target="_blank" rel="noopener noreferrer" className="link-underline">LinkedIn</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-ivory/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-ivory/40">
          <div>© {new Date().getFullYear()} Audace & Perspectives. {t.footer.rights}</div>
          <div className="flex items-center gap-5 text-ivory/55">
            <Link to="/mentions-legales" data-testid="footer-legal" className="hover:text-ivory transition-colors">{legalLabel}</Link>
            <span className="text-ivory/15">·</span>
            <Link to="/rgpd" data-testid="footer-rgpd" className="hover:text-ivory transition-colors">{rgpdLabel}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
